import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { CSSTransition } from "react-transition-group";
import { Form, Progress, Alert } from "reactstrap";
import { useLocalization, WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
        cp_convert:parameters.cp_convert
      },
      parameters
    )
    .then((response) => {
      setOnLogin(false)
      window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
    })
    .catch((error) => {
      const _translate = translate(error.errorCode);
      let message= translate("RequestLoginErrorMessage")
      if (_translate) {
        message=_translate;
      } else if (error.details) {
        message=error.details;
      }
      setOnLogin(false)
      setError({ open: true, message })
    });
  }

    return (
      <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
        <Form onSubmit={(event) => onSubmit(event)} className="login">
          <div className="wrapper-conectafoot fadeInDown" ref={nodeRef}>
            <div id="snackbar"></div>
              <div id="formContent-conectafoot">
                <div className="menu1-conectafoot">
                  <div className="fadeIn first">
                    <h1 className="conectafoot-title">
                      <span className="conecta-text">CONECTA</span>
                      <span className="foot-text">FOOT</span>
                    </h1>
                    <p className="welcome-message">
                      {translate("WelcomeMessage")}
                    </p>
                  </div>
                  <div className="form-fields">
                    <div className="field-group">
                      <label className="field-label">{translate("UserName")}</label>
                      <input
                        className="fadeIn second field-input"
                        disabled={onLogin}
                        onChange={e => setUsername(e.target.value)}
                        required={true}
                        tabIndex={1}
                        type="text"
                        autoCorrect="off"
                        autoCapitalize="none"
                        name="login"
                        id="login-conectafoot"
                        placeholder={translate("PlaceholderUserName")}
                      />
                    </div>
                    <div className="field-group">
                      <label className="field-label">{translate("Password")}</label>
                      <input
                        className="fadeIn third field-input"
                        required={true}
                        disabled={onLogin}
                        onChange={e => setPassword(e.target.value)}
                        tabIndex={1}
                        type="password"
                        autoCorrect="off"
                        autoCapitalize="none"
                        id="password-conectafoot"
                        name="login"
                        placeholder={translate("PlaceholderPassword")}
                      />
                    </div>
                  </div>
                  <div className="buttons-conectafoot">
                    {!onLogin ? (
                    <button type="submit" className="fadeIn fourth" id="entrar-conectafoot" disabled={!props.turnstileSuccess}>
                      <span className="entrar-text" id="text">
                        {translate("ButtonEnter")}
                      </span>
                    </button>
                    ) : (
                      <Progress animated color="danger" value={100} />
                    )}
                  </div>
                  <div className="messages-container">
                    <Alert
                      color="danger"
                      id="error-message"
                      isOpen={error.open}
                      toggle={() => setError({ open: false })}
                    >
                      {error.message}
                    </Alert>
                  </div>
                  <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
                </div>
            </div>
          </div>
        </Form>
      </CSSTransition>
    );
  }

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
